export default __webpack_public_path__ + "images/icon--mag-glass.svg";